<template>
  <div class="studioport chinese_container">
    <myHeader />
    <div class="studio_banner">
      <div class="studio_banner_content">
        <h1 class="fami">hecoos Studio</h1>
        <p class="TwoProductTitle">
          让每一个设计细节都精准呈现，最大限度管控从展演的灵感到最终<br />落地呈现的各个环节
        </p>
        <button
          id="cn_studio_download"
          class="callMe"
          @click="getdown"
          style="background-color: black"
        >
          立即下载
        </button>
      </div>
      <div class="gradient-bg">
        <div class="gradients-container">
          <div class="g1"></div>
          <div class="g2"></div>
          <div class="g3"></div>
          <div class="g4"></div>
          <div class="g5"></div>
          <div class="interactive"></div>
        </div>
      </div>
    </div>
    <div class="section_foundation">
      <div class="section_content">
        <p class="carousel-title wow fadeInUp">全域制作流程</p>
        <button class="watch-movie-button wow fadeInUp" @click="showVideo">
          <img
            src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png"
            alt=""
          />
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <!-- <video autoplay loop muted
            src="https://download.hecoos.com/enlightv/2025-17/3e04d9ef0313721c372a09dc4de0cfae.mp4"></video> -->
          <img
            src="https://download.hecoos.com/enlightv/2025-20/74f6eb95683bca36efb3951249c6fdcf.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div>
      <div class="product">
        <div class="tab">
          <p
            style="font-weight: 700; font-size: 30px"
            class="default_font wow fadeInUp"
          >
            概述
          </p>
          <p
            style="font-size: 72px; font-weight: 700; margin-top: 12px"
            class="wow fadeInUp ProductTitle"
          >
            核心功能点
          </p>
          <div class="switch" ref="switch_list">
            <!-- 为每个 span 绑定点击事件和动态类名 -->
            <span
              :class="{ select: currentTabIndex === 0 }"
              @click="selectTab(0)"
            >
              三维场景预演
            </span>
            <span
              :class="{ select: currentTabIndex === 1 }"
              @click="selectTab(1)"
            >
              投影光路设计
            </span>
            <span
              :class="{ select: currentTabIndex === 2 }"
              @click="selectTab(2)"
            >
              灯光预演与预编程
            </span>
            <span
              :class="{ select: currentTabIndex === 3 }"
              @click="selectTab(3)"
            >
              导播系统
            </span>
            <span
              :class="{ select: currentTabIndex === 4 }"
              @click="selectTab(4)"
            >
              现场控制
            </span>
            <div
              class="underline"
              :style="{
                width: underlineWidth + 'px',
                left: underlineLeft + 'px',
              }"
            ></div>
          </div>
        </div>
        <!-- 产品内容部分 -->
        <div>
          <div class="content1 flexContent">
            <div class="studio" v-show="showContents[0]">
              <img
                src="https://download.hecoos.com/enlightv/2025-37/b9a8561ed2d3a3bc239784458f646dd9.gif"
                alt=""
                class="wow fadeInUp"
                @click="handleClickStudioVideo('https://download.hecoos.com/enlightv/2025-37/6e569024f657be36a636d806995b2c05.mp4')"
              />
              <p class="textContent wow fadeInUp">
                hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障。
              </p>
            </div>
            <div class="studio" v-show="showContents[1]">
              <img
                src="https://download.hecoos.com/enlightv/2025-37/e2a6710b551d4589205a1859ac1839de.gif"
                @click="handleClickStudioVideo('https://download.hecoos.com/enlightv/2025-37/c2425b299fdea228a893c92c0941fec7.mp4')"
                alt=""
                class="wow fadeInUp"
              />
              <p class="textContent wow fadeInUp">
                模拟真实投影机的光路和画面畸变，精准测量投影机在实际环境中的照度和遮挡区域，通过内置多个品牌多种参数的投影机，轻松完成各种复杂模型的光路设计。
              </p>
            </div>
            <div class="studio" v-show="showContents[2]">
              <img
                src="https://download.hecoos.com/enlightv/2025-37/5ea6dc35423ef1a273401a7736ca289b.gif"
                alt=""
                @click="handleClickStudioVideo('https://download.hecoos.com/enlightv/2025-37/94bc0146f0b0954d3e1e0ac10295cbb6.mp4')"
                class="wow fadeInUp"
              />
              <p class="textContent wow fadeInUp">
                灯光效果对于舞台气氛的烘托极为重要，hecoos内置主流品牌灯具，基于Art-Net协议配接，实现灯光的预编程、现场真实灯具控制，模拟三维场景中真实光影效果，再现舞台现场灯光的绚丽多彩。
              </p>
            </div>
            <div class="studio" v-show="showContents[3]">
              <img
                src="https://download.hecoos.com/enlightv/2025-37/c799c3f249148bdac945f5455bf566f4.gif"
                alt=""
                @click="handleClickStudioVideo('https://download.hecoos.com/enlightv/2025-37/8d690d28c5a754ae6e38d5dc3dc97ca9.mp4')"
                class="wow fadeInUp"
              />
              <div class="textContent wow fadeInUp">
                <p>
                  内置多种类型摄像机(摇臂、轨道等)，提前预演摄像机拍摄画面，基于时间轴的控制方式，实现精准的导播切换。同时可基于CUE点管理生成电子台本，将导播设计和现场执行无缝对接，通过云端来实现协同工作，可完成无人值守的导播切换任务
                </p>
              </div>
            </div>

            <div class="studio" v-show="showContents[4]">
              <img
                src="https://download.hecoos.com/enlightv/2025-37/c799c3f249148bdac945f5455bf566f4.gif"
                alt=""
                @click="handleClickStudioVideo('https://download.hecoos.com/enlightv/2025-37/ceace489abff2bfd1c57917adeea3a48.mp4')"
                class="wow fadeInUp"
              />
              <div class="textContent">
                <p>
                  Studio将预演工程与现场执行环节轻松串联，作为项目调试阶段多媒体设备的核心控制枢纽，Studio
                  凭借其精准的通讯与控制能力，确保各设备之间稳定、协调地运行。多人协同调试使团队协作更加流畅高效。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 会员注册 -->
    <div class="bg3">
      <div class="form-container">
        <h1 class="wow fadeInUp soul ProductTitle">会员注册</h1>

        <div class="register_content">
          <div class="input-group wow fadeInUp">
            <input
              type="text"
              placeholder="真实姓名"
              autocomplete="new-password"
              v-model="form.rname"
            />
            <input
              type="email"
              placeholder="邮箱"
              autocomplete="new-password"
              v-model="form.email"
            />
          </div>

          <div class="phone-verify-group wow fadeInUp">
            <div class="phone-verify-container">
              <input
                type="text"
                placeholder="手机号"
                v-model="form.phone"
                autocomplete="new-password"
                class="phone-input"
              />
              <button
                :disabled="!isPhoneValid || isCountingDown"
                @click="obtainCode"
                class="verify-code-button"
              >
                {{ isCountingDown ? `${countdown}s后重试` : "获取验证码" }}
              </button>
            </div>
            <input
              type="text"
              placeholder="验证码"
              autocomplete="new-password"
              v-model="form.verifyCode"
              class="verify-input"
            />
          </div>

          <div class="input-group wow fadeInUp">
            <input
              type="password"
              placeholder="设置密码"
              autocomplete="new-password"
              v-model="form.password"
            />
            <input
              type="password"
              placeholder="确认密码"
              autocomplete="new-password"
              v-model="form.confirmPassword"
            />
          </div>

          <div class="input-group wow fadeInUp">
            <input
              type="text"
              placeholder="所在公司名称"
              autocomplete="new-password"
              v-model="form.company"
            />
            <input
              type="text"
              placeholder="所在城市"
              autocomplete="new-password"
              v-model="form.city"
            />
          </div>

          <div class="input-group wow fadeInUp">
            <input
              type="text"
              placeholder="职位"
              v-model="form.position"
              autocomplete="new-password"
            />
            <!--            <input-->
            <!--              type="text"-->
            <!--              placeholder="从业时间"-->
            <!--              autocomplete="new-password"-->
            <!--              v-model="form.workDuration"-->
            <!--            />-->

            <select
              placeholder="从业时间"
              :class="{ none_select: !form.workDuration }"
              v-model="form.workDuration"
            >
              <option value="" disabled selected>从业时间</option>
              <option v-for="item in workDurationList" :value="item.name">
                {{ item.name }}
              </option>
            </select>
          </div>
          <p class="tip wow fadeInUp" style="text-align: left">
            为保证您能快速通过审核，请填写真实有效的信息
          </p>
          <button
            class="next-button wow fadeInUp"
            :disabled="!isButtonEnabled"
            @click="goRegister"
          >
            下一步
          </button>
        </div>
      </div>
    </div>
    <!-- 软件订阅 -->
    <div class="bg4">
      <div class="subscription-container wow fadeInUp">
        <h2 class="title wow fadeInUp ProductTitle">软件订阅</h2>
        <div class="subscription_container">
          <div
            v-for="(item, index) in subscriptionOptions"
            :key="index"
            class="subscription-item"
          >
            <h3 :class="getClass(item.stylecolor)">{{ item.title }}</h3>
            <div v-if="item.price" class="price">
              {{ item.price }}<span class="z">/周</span>
            </div>
            <p v-else class="description">{{ item.description }}</p>
            <button class="btn" @click="goToPage(item)">进一步了解</button>
          </div>
        </div>
      </div>
    </div>

    <div class="bg6">
      <div id="app">
        <!-- 下载部分 -->
        <div class="download-section wow fadeInUp">
          <div class="left-content">
            <img
              src="https://download.hecoos.com/enlightv/2025-17/5943a715df38eb4f86c5d9e218bd51dd.png"
              alt="下载图标"
            />
          </div>
          <div class="right-content wow fadeInUp">
            <h2>下载</h2>
            <p>立即下载，熟悉软件，开始创建新现实！</p>
            <div class="le">
              <button class="download-btn" @click="getdown">软件下载</button>

              <a href="https://download.hecoos.com/hecoos/hecoosGuide.pdf"
                ><button class="guide-btn">下载指南</button></a
              >
            </div>
          </div>
        </div>
        <!-- 学习方案部分 -->
        <div class="learning-plan-section">
          <div class="left-content wow fadeInUp">
            <h2>学习方案</h2>
            <p>适合您需求和节奏的学习体验。</p>
            <div class="le">
              <router-link
                :to="{ name: 'videoTutorial', hash: '#specific-position' }"
                class="setting_a2"
              >
                <button class="more-btn">了解更多</button>
              </router-link>
              <router-link
                :to="{
                  name: 'chCaseDemonstration',
                  hash: '#specific-position',
                }"
                class="setting_a2"
              >
                <button class="customize-btn">定制您的学习方案</button>
              </router-link>
            </div>
          </div>
          <div class="right-content wow fadeInUp">
            <img
              src="https://download.hecoos.com/enlightv/2025-17/f7ffa329c3461ca49c38e4a61a158e39.png"
              alt="学习场景"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <myText /> -->
    <myInquire />
    <myFooter />
    <BackToTop></BackToTop>
    <videoPlayback
      v-if="showVideoPlayer"
      @close="handleCloseVideo"
      :videoUrl="videoUrl"
    />

    <div class="studio_video_mask_layer" v-if="studioVideoDetail">
      <button class="video_close" @click="handleClickCloseStudioVideoMask">&times;</button>
      <div class="video_box">
        <video  :src="studioVideoDetail"  autoplay  controls  muted ></video>
      </div>
    </div>
  </div>
</template>

<script>
import { getOSSData } from "@/utils/uploadOss.js";
import BackToTop from "@/components/pc/BackToTop";
import myFooter from "@/components/pc/myFooter.vue";
import myHeader from "@/components/pc/myHeader.vue";
import myInquire from "@/components/pc/myInquire.vue";
// import MyText from "@/components/pc/myText.vue";
import videoPlayback from "@/components/pc/videoPlayback.vue";
import axios from "axios";
import { getCaptcha, adminRegister } from "@/api/api";
import { Message } from "element-ui";
export default {
  components: {
    myHeader,
    myFooter,
    myInquire,
    // MyText,
    BackToTop,
    videoPlayback,
  },

  data() {
    return {
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false, false, false],
      form: {
        rname: "",
        phone: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
        email: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
      },
      isCountingDown: false,
      countdown: 60,
      errorMessages: [], // 新增：收集所有错误信息

      bannertext:
        "hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障",

      formRows: [
        [
          {
            label: "真实姓名",
            type: "input",
            inputType: "text",
            name: "realName",
            placeholder: "真实姓名", // 添加占位符文本
          },
          {
            label: "邮箱",
            type: "input",
            inputType: "email",
            name: "email",
            placeholder: "邮箱", // 添加占位符文本
          },
        ],
        [
          {
            label: "手机号",
            type: "input-with-button",
            inputType: "text",
            name: "phone",
            clickHandler: function () {
              this.sendVerificationCode();
            },
            text: "获取验证码",
            placeholder: "手机号", // 添加占位符文本
          },
          {
            label: "验证码",
            type: "input",
            inputType: "text",
            name: "verificationCode",
            placeholder: "验证码", // 添加占位符文本
          },
        ],
        [
          {
            label: "设置密码",
            type: "input",
            inputType: "password",
            name: "password",
            placeholder: "设置密码", // 添加占位符文本
          },
          {
            label: "确认密码",
            type: "input",
            inputType: "password",
            name: "confirmPassword",
            placeholder: "确认密码", // 添加占位符文本
          },
        ],
        [
          {
            label: "所在公司名称",
            type: "input",
            inputType: "text",
            name: "companyName",
            placeholder: "所在公司名称", // 添加占位符文本
          },
          {
            label: "所在城市",
            type: "input",
            inputType: "text",
            name: "city",
            placeholder: "所在城市", // 添加占位符文本
          },
        ],
        [
          {
            label: "职位",
            type: "input",
            inputType: "text",
            name: "position",
            placeholder: "职位", // 添加占位符文本
          },
          {
            label: "从业时间",
            type: "input",
            inputType: "text",
            name: "workExperience",
            placeholder: "从业时间", // 添加占位符文本
          },
        ],
      ],
      formData: {},
      isSending: false,
      countdown: 60,
      timer: null,

      subscriptionOptions: [
        {
          title: "订阅版",
          stylecolor: "color_one",
          price: "¥98",
          path: "/SoftwareSubscriptions",
        },
        {
          title: "离线版",
          description: "独立加密锁，离线亦可工作",
          path: "/offlineversion",
          stylecolor: "color_two",
        },
      ],

      hue1: 0,
      hue2: 0,
      showVideoPlayer: false,
      videoUrl:
        "https://download.hecoos.com/enlightv/2025-17/a7b39397e5b52ac2f16d0e201a71d1f3.mp4",

      workDurationList: [
        { name: "1年" },
        { name: "2年" },
        { name: "3年" },
        { name: "4年" },
        { name: "5年" },
        { name: "6年" },
        { name: "7年" },
        { name: "8年" },
        { name: "9年" },
        { name: "10年以上" },
      ],
      studioVideoDetail:''
    };
  },
  mounted() {
    window.addEventListener("mousemove", this.handleMouseMove);
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  computed: {
    isButtonEnabled() {
      return (
        // 所有必填字段都填写且密码一致
        this.form.rname &&
        this.form.email &&
        this.form.phone &&
        this.form.verifyCode &&
        this.form.password &&
        this.form.confirmPassword &&
        this.form.company &&
        this.form.city &&
        this.form.position &&
        this.form.workDuration &&
        this.form.password === this.form.confirmPassword
      );
    },
    isPhoneValid() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(this.form.phone);
    },
  },

  methods: {
    //     handleClick(index) {
    //   // 这里可以根据点击的选项index，实现具体的业务逻辑，比如跳转到对应详情页
    //   console.log(`点击了${this.subscriptionOptions[index].title}的进一步了解按钮`);
    // }
    handleClickStudioVideo(video_src){
      this.studioVideoDetail =video_src
    },
    handleClickCloseStudioVideoMask(){
      this.studioVideoDetail = ''
    },
    getClass(colorClass) {
      const classMap = {
        color_one: "class-one",
        color_two: "class-two",
      };
      return classMap[colorClass] || "";
    },
    handleMouseMove(event) {
      const x = event.clientX / window.innerWidth;
      const y = event.clientY / window.innerHeight;

      this.hue1 = Math.floor(x * 360);
      this.hue2 = Math.floor(y * 360);
    },
    // 显示视频播放器
    showVideo() {
      this.showVideoPlayer = true;
      document.body.style.overflow = "hidden"; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = "auto"; // 恢复页面滚动
    },

    // goVedio() {
    //   window
    //     .open
    //     // "https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4"
    //     ();
    // },
    // goToAbout() {
    //   this.$router.push("https://www.artbook.top/");
    // },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
    goToPage(item) {
      this.$router.push({ path: item.path });
    },

    //下载软件接口
    getdown() {
      const config = {
        method: "post", // 请求方法
        url: "https://www.hecoos.com/api/index/hecoosPath", // 请求 URL
        timeout: 5000, // 请求超时时间（毫秒）
      };
      axios(config)
        .then((res) => {
          if (res) {
            const { version, packageUrl } = res.data;
            let file_name = `hecoos Studio v${version}.exe`;
            getOSSData(packageUrl, file_name);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    jumpTo(url) {
      this.$router.push(url);
    },
    // 中文姓名校验
    checkRname(str) {
      let reg = /^[\u4e00-\u9fa5]{2,}$/;
      return reg.test(str);
    },

    // 邮箱校验
    isEmailValid(str) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(str);
    },

    // 验证码校验（6位数字）
    checkVerifyCode(str) {
      let reg = /^\d{6}$/;
      return reg.test(str);
    },

    // 密码校验
    checkPassword(str) {
      return str.length >= 6;
    },

    // 公司名称校验（至少2个汉字）
    checkCompany(str) {
      let reg = /^[\u4e00-\u9fa5]{2,}$/;
      return reg.test(str);
    },

    // 城市校验（中文）
    checkCity(str) {
      let reg = /^[\u4e00-\u9fa5]+$/;
      return reg.test(str);
    },

    // 职位校验（至少2个字符）
    checkPosition(str) {
      let reg = /^.{2,}$/;
      return reg.test(str);
    },

    // 工作年限校验（数字或数字+年）
    checkWorkDuration(str) {
      let reg = /^\d+(\s*年)?$/;
      return reg.test(str);
    },

    obtainCode() {
      // 先校验手机号格式
      if (!this.isPhoneValid) {
        Message.error("请输入正确的手机号格式");
        return;
      }

      let postData = {
        phone: this.form.phone,
      };
      getCaptcha(postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },

    goRegister() {
      // 执行完整表单校验
      if (!this.validateForm()) {
        return;
      }

      adminRegister(this.form).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/login");
        } else {
          Message.error(res.message || "注册失败，请重试");
        }
      });
    },
    validateForm() {
      const errors = [];

      // 收集所有错误
      if (!this.checkRname(this.form.rname))
        errors.push("请输入中文姓名（至少2个字符）");
      if (!this.isPhoneValid) errors.push("手机号格式不正确，请重新输入");
      if (!this.isEmailValid(this.form.email))
        errors.push("邮箱格式不正确，请重新输入");
      if (this.form.verifyCode && !this.checkVerifyCode(this.form.verifyCode))
        errors.push("请输入6位数字的验证码");
      if (this.form.password && !this.checkPassword(this.form.password))
        errors.push("密码长度至少为6位");
      if (this.form.password !== this.form.confirmPassword)
        errors.push("两次输入的密码不一致");
      if (!this.checkCompany(this.form.company))
        errors.push("请输入正确的公司名称（至少2个汉字）");
      if (!this.checkCity(this.form.city)) errors.push("请输入中文城市名称");
      if (!this.checkPosition(this.form.position))
        errors.push("请输入职位（至少2个字符）");
      if (!this.checkWorkDuration(this.form.workDuration))
        errors.push("请输入正确的从业时间（如：1年、3）");

      // 延迟显示错误
      if (errors.length > 0) {
        errors.forEach((msg, index) => {
          setTimeout(() => {
            Message.error(msg);
          }, 500 * index);
        });
        return false;
      }

      return true;
    },
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/studio_banner.scss";
</style>
<style scoped lang="scss">
@import "@/styles/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
.fami {
  font-family: YourFontName;
}

.product {
  width: 100%;
}

.tab {
  /* height: 500px; */
  background-color: #e8e8f1;
  text-align: center;
  color: #000;
  padding: 80px 120px 0;
}

.switch {
  margin-top: 30px;
  position: relative;

  span {
    display: inline-block;
    margin: 0 25px;
    font-size: 24px;
    font-weight: 700;
    padding: 10px 5px;
    line-height: 50px;
    cursor: pointer;
  }
}

.select {
  // border-bottom: 3px solid #2a82e4;
}

.content1 {
  width: 100%;
  background-color: #121416;
  color: #fff;
}
.flexContent {
  padding: 80px 120px;
  .studio {
    // padding: 80px 120px;
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    gap: 40px;
    overflow: hidden;
    img {
      width: 50%;
    }
    .textContent {
      flex: 1;
      margin-top: 0px;
      // text-indent: 48px;
      line-height: 38px;
      // text-align: justify;
      // margin-bottom: 30px;
      // vertical-align: top;
      text-align: left;
      font-size: 24px;
    }
  }
}
// .studio {
//   padding: 80px 120px;

//   img {
//     display: block;
//     margin: 0 auto;
//     width: 1058px;
//     height: 682px;
//   }
// }

// .textContent {
//   width: 1058px;
//   height: 100px;
//   margin: 30px auto 0;
//   font-size: 24px;
//   text-align: left;
// }

.underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #2a82e4;
  transition: all 0.3s ease;
}

.callMe {
  display: block;
  text-decoration: none;
  color: #fff;
  width: 151px;
  height: 50px;
  line-height: 50px;
  border-radius: 25px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}

.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
}

.register_content {
  width: 100%;

  border-radius: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
}

.register_content h2 {
  margin-bottom: 20px;
  font-size: 32px;
}

.register_content p {
  margin-bottom: 30px;
  font-size: 20px;
}

.input-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.input-group input,
.input-group select,
.phone-verify-group input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 18px;
  transition: border-color 0.3s;
}
.input-group select.none_select {
  color: #757575;
}
.input-group select:focus-visible {
  border: none;
  outline: none;
}
.phone-verify-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.phone-verify-container {
  display: flex;
  width: 48%;
  position: relative;
}

.phone-input {
  flex: 1;
  font-size: 18px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #333;
  color: #fff;
  width: 100%;
  height: auto;
}

.verify-code-button {
  width: 120px;
  padding: 14px 10px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  height: auto;
  position: absolute;
  right: 0;
  font-size: 18px;
}

.verify-input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  height: auto;
  font-size: 18px;
}

.next-button {
  width: 100%;
  padding: 16px 0;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 22px;
  transition: all 0.3s;
}

.next-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.link-container {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
</style>
